export default {
  heading: 'Playfair, serif',
  body: 'Montserrat, sans-serif',
  monospace: 'Menlo, monospace',
  display: 'Bromello Regular, san-serif',
  googleFonts: ['Playfair:300,400,500,600,700,800,900', 'Montserrat:100,200,300,400,500,600,700,800,900'],
  customFamilies: ['Bromello Regular'],
  customUrls: ['https://gonation.biz/fonts/bromello-regular/bromello-regular.css']
}
